import React from "react";
import PropTypes from "prop-types";
import useMatchSnapshot from "../../hooks/match/useMatchSnapshot";

import {
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonIcon,
  IonImg,
  IonRouterLink,
  IonText,
} from "@ionic/react";
import { calendarOutline } from "ionicons/icons";

import "./styles/SavedMatchCard.scss";
import { FormattedMessage } from "react-intl";
import ScoreIndicator from "../MatchCard/sub/ScoreIndicator";
import CurrentPlayerIndicator from "../CurrentPlayerIndicator/CurrentPlayerIndicator";

function SavedMatchCard({ data, imageUrl = "match.png", className }) {
  const { data: rtMatch } = useMatchSnapshot(`/matches/${data.id}`);
  const safeMatch = rtMatch || data;
  const servingPlayer = safeMatch?.currentStatus?.current_player;
  const servingPlayerId = servingPlayer?.athleteId;

  console.log("SavedMatchCard", rtMatch);
  const status =
    safeMatch &&
      safeMatch.currentStatus &&
      safeMatch.currentStatus.phase === "game_over"
      ? "Terminata"
      : "In corso";
  return (
    <IonRouterLink
      routerLink={`/match/${safeMatch.id}`}
      style={{ textDecoration: "none" }}
    >
      <IonCard
        style={{ display: "flex", flexDirection: "row" }}
        className={className ? `SavedMatchCard ${className}` : "SavedMatchCard"}
      >
        <IonImg
          src={imageUrl}
          style={{
            width: "55px",
            paddingLeft: "1rem",
            boxSizing: "content-box",
          }}
        />
        <IonCardContent style={{ flex: 1, paddingLeft: "1rem" }}>
          <IonText>
            <h5>
              <IonIcon icon={calendarOutline}></IonIcon>
              {new Date(data.start_time._seconds * 1000).toLocaleString()}
            </h5>
          </IonText>
          <IonCardTitle>
            <FormattedMessage id={safeMatch.type} />
          </IonCardTitle>
          <IonText>
            <h5>
              {/* <IonIcon icon={peopleOutline}></IonIcon> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex" }}>
                  {safeMatch.team_a.map((player) => (
                    <div
                      key={player.id}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        fontWeight: "bold",
                        gap: "0.25rem",
                      }}
                    >
                      {player.name}
                      <div className="MatchCard_Player_Indicator">
                        {player.athleteId === servingPlayerId && (
                          <CurrentPlayerIndicator />
                        )}
                      </div>
                    </div>
                  ))}
                  <div style={{ marginLeft: "auto" }}>
                    <ScoreIndicator
                      completedSets={
                        safeMatch?.currentStatus?.completedSets.team_a
                      }
                      data={safeMatch?.currentStatus?.team_a}
                      status={safeMatch?.currentStatus}
                    />
                  </div>
                </div>
                <hr
                  style={{
                    border: "none",
                    margin: "0.25rem 0",
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#ccc",
                  }}
                />
                <div style={{ display: "flex" }}>
                  {safeMatch.team_b.map((player) => (
                    <div
                      key={player.id}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        fontWeight: "bold",
                        gap: "0.25rem",
                      }}
                    >
                      {player.name}
                      <div className="MatchCard_Player_Indicator">
                        {player.athleteId === servingPlayerId && (
                          <CurrentPlayerIndicator />
                        )}
                      </div>
                    </div>
                  ))}
                  <div style={{ marginLeft: "auto" }}>
                    <ScoreIndicator
                      completedSets={
                        safeMatch?.currentStatus?.completedSets.team_b
                      }
                      data={safeMatch?.currentStatus?.team_b}
                      status={safeMatch?.currentStatus}
                    />
                  </div>
                </div>
              </div>
            </h5>
          </IonText>
          <IonText>
            <h5>
              <FormattedMessage id={safeMatch.mode} />
            </h5>
          </IonText>
          <IonText>
            <h5>
              <FormattedMessage id={status} />
            </h5>
          </IonText>
        </IonCardContent>
      </IonCard>
    </IonRouterLink>
  );
}

SavedMatchCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    start_time: PropTypes.shape({ _seconds: PropTypes.number }),
    team_a: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        athleteId: PropTypes.string.isRequired,
      }),
    ).isRequired,
    team_b: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        athleteId: PropTypes.string.isRequired,
      }),
    ).isRequired,
    mode: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  imageUrl: PropTypes.string,
  className: PropTypes.string,
};

export default SavedMatchCard;
